import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import {
  AccountInfo,
  AuthenticationResult,
  EndSessionRequest,
  EventType,
  RedirectRequest,
  SilentRequest,
} from '@azure/msal-browser';
import { Observable, of, ReplaySubject } from 'rxjs';

@Injectable()
export class PitMsalService {
  private accountSubject!: ReplaySubject<AccountInfo>;
  constructor(private msalService: MsalService) {}
  getAccount(): AccountInfo {
    return this.msalService.instance.getAllAccounts()[0];
  }
  getAccount$(): Observable<AccountInfo> {
    const cachedAccount = this.msalService.instance.getAllAccounts();
    if (cachedAccount.length) {
      return of(this.getAccount());
    }
    if (this.accountSubject) {
      return this.accountSubject;
    }
    this.accountSubject = new ReplaySubject<AccountInfo>(1);
    this.msalService.instance.addEventCallback(event => {
      if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
        this.accountSubject.next(this.getAccount());
      }
    });
    return this.accountSubject;
  }
  logout(logoutRequest?: EndSessionRequest): Observable<void> {
    return this.msalService.logout(logoutRequest);
  }
  acquireTokenSilent(silentRequest: SilentRequest): Observable<AuthenticationResult> {
    return this.msalService.acquireTokenSilent(silentRequest);
  }
  acquireTokenRedirect(request: RedirectRequest): Observable<void> {
    return this.msalService.acquireTokenRedirect(request);
  }
  loginRedirect(request?: RedirectRequest): Observable<void> {
    return this.msalService.loginRedirect(request);
  }
  handleRedirectObservable(hash?: string): Observable<AuthenticationResult> {
    return this.msalService.handleRedirectObservable(hash);
  }
}
